import type { Screen } from "../app/types";
import type { ProgressSnapshot } from "../progress/session";
import { Icon } from "./Icon";

export interface NavigationProps {
  readonly onNavigate: (screen: Screen) => void;
}

export function Header({
  onNavigate,
  progress,
  active = "home",
}: NavigationProps & {
  readonly progress: ProgressSnapshot;
  readonly active?: Screen;
}) {
  const progressLabel =
    progress.mode === "account"
      ? "云端已同步"
      : progress.mode === "conflict"
        ? "待合并进度"
        : progress.mode === "syncing"
          ? "正在同步"
          : progress.mode === "storage-unavailable"
            ? "暂未保存"
            : progress.user
              ? "账户本地进度"
              : "本地存档";
  return (
    <header className="site-header">
      <button
        className="brand-lockup text-button"
        onClick={() => onNavigate("home")}
        aria-label="返回 Gloamline 首页"
      >
        <svg
          className="brand-mark"
          viewBox="0 0 40 40"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M29 10c-8-6-20-1-20 8s19 0 21 9-11 11-17 5"
            stroke="currentColor"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <circle cx="29" cy="10" r="3" className="brand-mark-accent" />
        </svg>
        <span className="brand-word">
          GLOAMLINE<small>暮光线迹</small>
        </span>
      </button>
      <nav className="site-nav" aria-label="主导航">
        <button
          className="nav-button"
          aria-label="大厅"
          aria-current={active === "home" ? "page" : undefined}
          onClick={() => onNavigate("home")}
        >
          <Icon name="play" />
          <span>大厅</span>
        </button>
        <button
          className="nav-button"
          aria-label="外观"
          aria-current={active === "appearance" ? "page" : undefined}
          onClick={() => onNavigate("appearance")}
        >
          <Icon name="skins" />
          <span>外观</span>
        </button>
        <button
          className="nav-button"
          aria-label="设置"
          aria-current={active === "settings" ? "page" : undefined}
          onClick={() => onNavigate("settings")}
        >
          <Icon name="settings" />
          <span>设置</span>
        </button>
      </nav>
      <div className="status-cluster">
        <span className="storage-status">
          <i className="status-dot" />
          {progressLabel}
        </span>
        <a
          className="header-link"
          href="https://leolixin.com/"
          aria-label="个人主页"
        >
          <span className="header-link-label">个人主页</span>
          <Icon name="arrow" />
        </a>
      </div>
    </header>
  );
}
